/**
 * Payload type options for PageTitle decorator.
 */
type PageTitleOptions = { keepDefaultTitle: boolean };

/**
 * Default <title/> value.
 */
const defaultTitle = process.env.VUE_APP_TITLE_DEFAULT || 'Warren Brasil';

/**
 * Reset html page title to default value.
 */
const resetPageTitle = () => {
  if (document && defaultTitle) {
    document.title = defaultTitle;
  }
};

/**
 * Decorator that maps a property to document.title (<title></title>).
 * Every time property changes then title tag also changes.
 */
const PageTitle = (options: PageTitleOptions = { keepDefaultTitle: true }) => {
  return function (target: Object, propertyKey: string) {
    let value: string;
    const getter = function () {
      return value;
    };
    const setter = function (newVal: string) {
      if (document && newVal) {
        let title = newVal;

        if (options.keepDefaultTitle && defaultTitle) {
          title = `${defaultTitle} - ${newVal}`;
        }

        document.title = title;
      }
      value = newVal;
    };
    Object.defineProperty(target, propertyKey, {
      get: getter,
      set: setter
    });
  };
};

export { PageTitle, resetPageTitle };
